import Endpoints from '../../../enums/Endpoints';
import { apiClient } from '../../../axios';

export type VisitaAFacturarRecepcionVacioImportLiquidar = {
  numero: string;
  marca: string;
  isoCodigo: string;
  isoTamano: number;
  isoTipo: string;
  noHacerAltaLibre: boolean;
  tieneCertificadoImo: boolean;
  notificacionImo: boolean;
};

export type LiquidarRecepcionVacioImportBody = {
  visitas: VisitaAFacturarRecepcionVacioImportLiquidar[];
  codigoArmador: string;
  tipoDeDocumento: string;
  esProforma: boolean;
  rutTitular: string;
  liquidando: boolean;
  lavado: string;
};

export const liquidarRecepcionVacioImport = async (
  body: LiquidarRecepcionVacioImportBody
) => {
  const res = await apiClient.post(
    Endpoints.LiquidarRecepcionVacioImport,
    body
  );
  return res.data.value[1];
};
